"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../common");
const core_1 = require("@emotion/core");
const Styles_1 = require("../common/Styles");
const SearchInput = react_1.forwardRef(({ ariaLabel, hasIcon, isDisabled, placeholder = 'Search…', onChange, onReset, value, }, ref) => {
    const inputRef = react_1.useRef(null);
    react_1.useImperativeHandle(ref, () => ({
        focus() {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        },
    }));
    const onClear = () => {
        onReset();
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    return (core_1.jsx(common_1.TextInput, { ariaLabel: ariaLabel, isDisabled: isDisabled, onChange: (e) => onChange(e.target.value), placeholder: placeholder, ref: inputRef, renderIconAfter: ({ iconSize }) => value ? (core_1.jsx("button", { "aria-label": "Clear search input", css: Styles_1.inputButtonStyle, onClick: onClear },
            core_1.jsx(design_system_1.Icon, { name: "x", size: iconSize }))) : null, renderIconBefore: ({ iconSize }) => hasIcon ? core_1.jsx(design_system_1.Icon, { name: "magnifyingGlass", size: iconSize }) : null, value: value }));
});
exports.default = SearchInput;
